import { TYC } from 'constants/api'
import useAxios from 'axios-hooks'
import LoadingScreen from 'components/loading-screen'
import styled from 'styled-components'
import { Type } from 'theme/types'
import ErrorView from 'components/error-view'
import useRouter from 'hooks/use-router'
import styles from './styles.module.scss'

const Div = styled.div`
  ${({ theme }: Type) => theme?.termsAndConditions?.div}
`

const TYCPage = () => {
  const { push } = useRouter()
  const [{ loading, error, data }] = useAxios({
    url: TYC
  })

  if (error) {
    return <ErrorView code={9999} buttonMenu={() => push('/home')} />
  }

  if (loading) {
    return <LoadingScreen />
  }

  if (data) {
    return <Div className={styles.wrapper}>
      <div dangerouslySetInnerHTML={{ __html: data }}></div>
    </Div>
  }
}

export default TYCPage
